export const SET_ACTIVE_BASE_LAYER = 'SET_ACTIVE_BASE_LAYER';
export const SET_ACTIVE_GRAPH_LAYER = 'SET_ACTIVE_GRAPH_LAYER';
export const SET_SHOW_ACTIVE_GRAPH_LAYER = 'SET_SHOW_ACTIVE_GRAPH_LAYER';
export const SHOW_GEO_LOCATION = 'SHOW_GEO_LOCATION';
export const HIDE_GEO_LOCATION = 'HIDE_GEO_LOCATION';
export const SET_BBOX_MAP = 'SET_BBOX_MAP';

export const setActiveBaseLayer = activeBaseLayer => {
  return {
    type : SET_ACTIVE_BASE_LAYER,
    activeBaseLayer: activeBaseLayer
  };
};

export const setActiveGraphLayer = activeGraphLayer => {
  return {
    type: SET_ACTIVE_GRAPH_LAYER,
    activeGraphLayer
  };
};

export const setShowActiveGraphLayer = showActiveGraphLayer => {
  return {
    type: SET_SHOW_ACTIVE_GRAPH_LAYER,
    showActiveGraphLayer
  };
};

export const showGeoLocation = position => {
  return {
    type: SHOW_GEO_LOCATION,
    position
  };
};

export const hideGeoLocation = () => {
  return {
    type: HIDE_GEO_LOCATION
  };
};

export const setBboxMap = (bbox) => {
  return {
    type: SET_BBOX_MAP,
    bbox
  };
};